"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.standardisationSchemaDef = void 0;
const joi_1 = __importDefault(require("joi"));
const __1 = require("..");
const __2 = require("../..");
const general_1 = require("../general");
exports.standardisationSchemaDef = Object.assign(Object.assign({}, general_1.daoObjSchemaDef), { businessUnitId: joi_1.default.string().required(), centre: (0, __2.objectSchema)(__1.entryCentreSchemaDef).required(), seriesId: joi_1.default.number().required(), assessment: joi_1.default.object({
        version: __1.assessmentSchemaDef.version,
        code: __1.assessmentSchemaDef.code,
    }).required(), componentNumber: joi_1.default.string().required(), isFlaggedForStandardisation: joi_1.default.boolean().required() });
